// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1jrP_","title":"Images45_title__21h3B","images":"Images45_images__O3qOJ"};